"use client";

import { InfiniteScroll } from "@/components/core/InfiniteScroll/InfiniteScroll";
import { useFetchMyPurchases } from "@/hooks/order/useFetchMyPurchases";
import { hasLoadedListItems } from "@/lib/pagination/hasLoadedListItems";
import { OrderItem } from "./OrderItem";
import { OrderItemSkeleton } from "./OrderItemSkeleton";
import { OrdersEmptyState } from "./OrdersEmptyState";

interface OrdersContentProps {
  tabType: "products" | "services" | "nft";
}

export const OrdersContent = ({ tabType }: OrdersContentProps) => {
  const isProduct = tabType === "products";
  const isService = tabType === "services";

  // For now, only handle products and services. NFT can be added later
  const orders = useFetchMyPurchases({
    isProduct: isProduct ? true : isService ? false : undefined,
    limit: 10,
    enabled: isProduct || isService,
  });

  const allOrders = orders.data?.pages.flatMap(
    (page) => page?.data?.result || [],
  );

  // Show loading state (only on initial load)
  if (orders.isLoading && !hasLoadedListItems(orders)) {
    return (
      <div>
        {Array.from({ length: 3 }, (_, i) => {
          const skeletonId = `skeleton-${i}`;
          return <OrderItemSkeleton key={skeletonId} />;
        })}
      </div>
    );
  }

  // Show empty state
  if (!allOrders || allOrders.length === 0) {
    return <OrdersEmptyState />;
  }

  return (
    <>
      {allOrders.map((order) => (
        <OrderItem key={order.id} order={order} />
      ))}

      {/* Infinite scroll trigger */}
      <InfiniteScroll query={orders} className="py-4" />
    </>
  );
};
